import React from 'react';
import { Box, Container, Typography } from '@mui/material';

import KeenSlider from '../../Layouts/KeenSlider';

import LearnerProfile from '../../Community/OneistoxLearner/LearnerProfile';

const RecommendedProfile = ({ data }) => {
  const settings = {
    slides: {
      spacing: 10,
      perView: () => {
        return window.innerWidth / 375;
      },
    },
    loop: true,
    mode: 'snap',
    breakpoints: {
      '(min-width: 960px)': {
        slides: {
          spacing: 29,
          perView: () => {
            return window.innerWidth / 680;
          },
        },
      },
      '(min-width: 1200px)': {
        slides: {
          spacing: 29,
          perView: () => {
            return window.innerWidth / 780;
          },
        },
      },
    },
  };

  return (
    <Box py={{ xs: 6, md: 12 }} bgcolor="tertiary.black" color="#fff">
      <Container>
        <Typography gutterBottom variant="h4" component="h4">
          {data?.title}
        </Typography>
        <Typography variant="body1">{data?.sub}</Typography>
        <Box mt={9}>
          <KeenSlider settings={settings}>
            {data?.recommended.map((data, key) => (
              <Box
                borderRadius={1}
                bgcolor="#99807b"
                px={{ xs: 2, md: 3 + '2px' }}
                py={{ xs: 2, md: 4 + '4px' }}
                key={key}
                className="keen-slider__slide"
              >
                <LearnerProfile data={data} isProfilePage />
              </Box>
            ))}
          </KeenSlider>
        </Box>
      </Container>
    </Box>
  );
};

export default RecommendedProfile;
